import prepareComponent from "@bluframe/grapple/prepareComponent"
import { Props as JobTriggerActivityProps } from "components/Socials/JobTriggerActivity"
import { Props as JobTriggerPanelProps } from "components/Socials/JobTriggerPanel"
import { Props as ProspectQueueProps } from "components/Socials/ProspectQueue"

import Prospects from "./Prospects"

export interface Props extends JobTriggerPanelProps, ProspectQueueProps {
  jobTriggerActivity: JobTriggerActivityProps["activity"]
}

export interface ComponentProps extends Props {}

const usePrepareComponent = (props: Props): ComponentProps => {
  return {
    ...props
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Prospects
)
